<mat-dialog-content>
  <h1>Scheduled Hours Overrides</h1>
  <h2>{{ prepLocation.prepLocationTypeName }}</h2>
  <!-- make this permission dependent-->
  @if (authManager.doesCurrentAccountHaveAnyRole(["Division", "IT", "Admin"])) {
    <div>
      <p>Select to remove scheduled overrides</p>
    </div>
  }
  <div class="close-modal" (click)="onNoClick()">X</div>
  <div class="scroll-list">
    @for (ho of hoursOverrides; track ho; let i = $index) {
      <div (click)="setSelectedRow(i)" class="override-container" [ngClass]="{ highlight: selectedIndex === i }">
        <div>
          <h3 class="override-date light-bold">{{ ho.date | date: "fullDate" }}</h3>
          @if (!ho.isClosedForDay) {
            <div class="light-gray-text override-time">
              @if (ho.openTime) {
                Open {{ ho.openTime | overrideTimeView }}
              }
              @if (ho.openTime && ho.closeTime) {
                -
              }
              @if (ho.closeTime) {
                Close {{ ho.closeTime | overrideTimeView }}
              }
            </div>
          }
          @if (ho.isClosedForDay) {
            <div class="light-gray-text override-time">Closed For Day</div>
          }
        </div>
        @if (selectedIndex === i) {
          <div>
            @if (authManager.doesCurrentAccountHaveAnyRole(["Division", "IT", "Admin"])) {
              <div>
                <button mat-raised-button color="warn" (click)="deleteOverrideConfirm(ho)">Remove</button>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  <p class="light-gray-text">{{ hoursOverrides.length }} Scheduled</p>
</mat-dialog-content>
